export const initCenterNotification = (notification = {}) => ({
    ...notification,

    // 키가 처음부터 있어야 저장 중에 _id 를 넣었을 때 isCreate 가 따라 바뀐다
    _id: notification._id ?? null,

    _files: [...(notification._files || [])],
    files: [...(notification.files || [])],

    sites: [...(notification.sites || [])],

    subject: notification.subject ?? "",
    content: notification.content ?? "",

    isNotice: notification.isNotice ?? false,

    // 옛 단일 첨부(파일 경로 문자열). Y-knowledge 사용자 화면은 이 값만 보여 준다
    upload: notification.upload ?? null,

    createdAt: notification.createdAt ?? Date.now().toDateTime(),
});
